import { GridLegacy } from "@mui/material";
import { ParamSetOption } from "../../../Tools/ProjectX";
import { getParamColumnsOptions } from "../../../rcsgrid/GridTools/parseColumnTools";
import { defaultFieldInfo } from "../../../Tools/Tools";
import React from "react";

//Поля
export function getColumnOrg() {
  return {
    title: [
      {
        fieldName: "OrgName",
        title: "Название организации",
        level: 0,
        width: 200,
        collapseRecord: true,
        fieldInfo: {
          ...defaultFieldInfo,
          options: getParamColumnsOptions(ParamSetOption.Disabled),
        },
      },
      {
        fieldName: "None",
        title: "-//-",
        level: 0,
        width: 40,
        fieldInfo: {
          ...defaultFieldInfo,
          EditStyle: "4",
          options: getParamColumnsOptions(ParamSetOption.Disabled),
        },
      },
      {
        fieldName: "INN",
        title: "ИНН",
        level: 0,
        width: 120,
        fieldInfo: {
          ...defaultFieldInfo,
          options: getParamColumnsOptions(ParamSetOption.Disabled),
        },
      },
      {
        fieldName: "KPP",
        title: "КПП",
        level: 0,
        width: 120,
        fieldInfo: {
          ...defaultFieldInfo,
          options: getParamColumnsOptions(ParamSetOption.Disabled),
        },
      },
      {
        fieldName: "GroupName",
        title: "Группа",
        level: 0,
        width: 200,
        fieldInfo: {
          ...defaultFieldInfo,
          options: getParamColumnsOptions(ParamSetOption.Disabled),
        },
      },
      {
        fieldName: "ContragentIdent",
        title: "Идентификатор контрагента",
        level: 0,
        width: 200,
        fieldInfo: {
          ...defaultFieldInfo,
          options: getParamColumnsOptions(ParamSetOption.Disabled),
        },
      },
    ],
  };
}

export function getColumnBank() {
  return {
    title: [
      {
        fieldName: "OrgName",
        title: "Название Банка",
        level: 0,
        width: 200,
        collapseRecord: true,
        fieldInfo: {
          ...defaultFieldInfo,
          options: getParamColumnsOptions(ParamSetOption.Disabled),
        },
      },
      {
        fieldName: "None",
        title: "-//-",
        level: 0,
        width: 40,
        fieldInfo: {
          ...defaultFieldInfo,
          EditStyle: "4",
          options: getParamColumnsOptions(ParamSetOption.Disabled),
        },
      },
      {
        fieldName: "BIK",
        title: "ИНН",
        level: 0,
        width: 120,
        fieldInfo: {
          ...defaultFieldInfo,
          options: getParamColumnsOptions(ParamSetOption.Disabled),
        },
      },
      {
        fieldName: "COR",
        title: "КПП",
        level: 0,
        width: 120,
        fieldInfo: {
          ...defaultFieldInfo,
          options: getParamColumnsOptions(ParamSetOption.Disabled),
        },
      },
    ],
  };
}

export function getColumnAccount() {
  return {
    title: [
      {
        fieldName: "AccName",
        title: "Название Счета",
        collapseRecord: true,
        level: 0,
        width: 200,
        fieldInfo: {
          ...defaultFieldInfo,
          options: getParamColumnsOptions(ParamSetOption.Disabled),
        },
      },
      {
        fieldName: "None",
        title: "-//-",
        level: 0,
        width: 40,
        fieldInfo: {
          ...defaultFieldInfo,
          EditStyle: "4",
          options: getParamColumnsOptions(ParamSetOption.Disabled),
        },
      },
      {
        fieldName: "BankName",
        title: "Банк",
        level: 0,
        width: 120,
        fieldInfo: {
          ...defaultFieldInfo,
          options: getParamColumnsOptions(ParamSetOption.Disabled),
        },
      },
      {
        fieldName: "GroupName",
        title: "Группа",
        level: 0,
        width: 120,
        fieldInfo: {
          ...defaultFieldInfo,
          options: getParamColumnsOptions(ParamSetOption.Disabled),
        },
      },
    ],
  };
}

// Чекбоксы
export function getCheckBoxes(props, hookCheckBox) {
  switch (props.module) {
    case "Объединить организации":
      return (
        <>
          <GridLegacy item style={{ marginLeft: "5px" }}>
            <label>
              <input
                id={"checkBox_orgGroup"}
                type={"checkbox"}
                onChange={() => {
                  hookCheckBox.Org.setGroup(!hookCheckBox.Org.Group);
                }}
              />
              В текущей группе
            </label>
          </GridLegacy>
          <GridLegacy
            item
            onChange={() => {
              hookCheckBox.Org.setName(!hookCheckBox.Org.Name);
            }}
            style={{ marginLeft: "5px" }}
          >
            <label>
              <input id={"checkBox_orgName"} type={"checkbox"} />
              ИМЯ
            </label>
          </GridLegacy>
          <GridLegacy
            item
            onChange={() => {
              hookCheckBox.Org.setINN(!hookCheckBox.Org.INN);
            }}
            style={{ marginLeft: "5px" }}
          >
            <label>
              <input id={"checkBox_orgINN"} type={"checkbox"} />
              ИНН
            </label>
          </GridLegacy>
          <GridLegacy
            item
            onChange={() => {
              hookCheckBox.Org.setKPP(!hookCheckBox.Org.KPP);
            }}
            style={{ marginLeft: "5px" }}
          >
            <label>
              <input id={"checkBox_orgKPP"} type={"checkbox"} />
              КПП
            </label>
          </GridLegacy>
        </>
      );
    case "Объединить банки":
      return (
        <>
          <GridLegacy
            item
            onChange={() => {
              hookCheckBox.Bank.setName(!hookCheckBox.Bank.Name);
            }}
            style={{ marginLeft: "5px" }}
          >
            <label>
              <input id={"checkBox_bankName"} type={"checkbox"} />
              ИМЯ
            </label>
          </GridLegacy>
          <GridLegacy
            item
            onChange={() => {
              hookCheckBox.Bank.setBIK(!hookCheckBox.Bank.BIK);
            }}
            style={{ marginLeft: "5px" }}
          >
            <label>
              <input id={"checkBox_bankBIK"} type={"checkbox"} defaultChecked={hookCheckBox.Bank.BIK} disabled />
              БИК
            </label>
          </GridLegacy>
        </>
      );
    case "Объединить Счета":
      return (
        <>
          <GridLegacy
            item
            onChange={() => {
              hookCheckBox.Account.setGroup(!hookCheckBox.Account.Group);
            }}
            style={{ marginLeft: "5px" }}
          >
            <label>
              <input id={"checkBox_accountGroup"} type={"checkbox"} />В текущей группе
            </label>
          </GridLegacy>
          <GridLegacy
            item
            onChange={() => {
              hookCheckBox.Account.setOneGroup(!hookCheckBox.Account.oneGroup);
            }}
            style={{ marginLeft: "5px" }}
          >
            <label>
              <input id={"checkBox_oneOrgGroup"} type={"checkbox"} />В пределах одной организации
            </label>
          </GridLegacy>
          <GridLegacy
            item
            onChange={() => {
              hookCheckBox.Account.setNumber(!hookCheckBox.Account.Number);
            }}
            style={{ marginLeft: "5px" }}
          >
            <label>
              <input id={"checkBox_number20"} type={"checkbox"} />
              Только 20-ти значные числа
            </label>
          </GridLegacy>
        </>
      );
  }
}
